import { KIND } from 'baseui/button'
import SDButton from '@/shared/components/SDComponents/SDButton/SDButton'
import { ModalSection } from '@/shared/components/SDComponents/SDModal/styled-components'
import useClubSelectra from '@/containers/SubscriptionFormPageNew/Components/ClubSelectra/useClubSelectra'
import SDNotification from '@/shared/components/SDComponentsNewDesign/SDNotification/SDNotification'

type ClubSelectraProps = {
  version: 'v2'
  module: 'contact' | 'save'
  hidden?: boolean
}

const ClubSelectra = ({ version, module, hidden }: ClubSelectraProps) => {
  const {
    t,
    labelsToShow,
    disabled,
    isLoading,
    message,
    error,
    isClubSelectraRegistered,
    createClubSelectra,
    isContactModule,
  } = useClubSelectra({ version, module })

  if (hidden) {
    return null
  }

  return (
    <ModalSection marginRight={!isContactModule}>
      {/* @ts-ignore */}
      <SDButton
        kind={KIND.secondary}
        block={true}
        isLoading={isLoading}
        onClick={createClubSelectra}
        disabled={disabled}
        overrides={{
          BaseButton: {
            style: () => ({
              marginTop: isContactModule ? 0 : '.5rem',
              marginBottom: isContactModule ? '1rem' : 0,
            }),
          },
        }}
      >
        {isClubSelectraRegistered === true
          ? t('subscriptionForm:header.modal_save_send.club_selectra_sent')
          : t('subscriptionForm:header.modal_save_send.club_selectra')}
      </SDButton>
      {labelsToShow?.length > 0 && (
        <div role='alert' style={{ marginTop: 8, fontSize: 12 }}>
          {t('subscriptionForm:header.modal_save_send.club_selectra_missing_fields')} {labelsToShow.join(', ')}
        </div>
      )}

      {message.length > 0 && (
        <SDNotification
          type='positive'
          icon={false}
          primaryText={message}
          overrides={{
            style: {
              paddingTop: '0.5rem',
              paddingRight: '0.5rem',
              paddingBottom: '0.5rem',
              paddingLeft: '0.5rem',
              marginTop: '0.5rem',
            },
          }}
        />
      )}

      {error.length > 0 && (
        <SDNotification
          type='negative'
          icon={false}
          primaryText={error}
          overrides={{
            style: {
              paddingTop: '0.5rem',
              paddingRight: '0.5rem',
              paddingBottom: '0.5rem',
              paddingLeft: '0.5rem',
              marginTop: '0.5rem',
            },
          }}
        />
      )}
    </ModalSection>
  )
}

export default ClubSelectra
